
namespace Matrix.Workflow {

    export interface ClientFunctionScheduleDialogOptions {
        Schedule: string;
    }

    @Serenity.Decorators.registerClass('Matrix.Workflow.ClientFunctionScheduleDialog')
    export class ClientFunctionScheduleDialog extends Serenity.PropertyDialog<any, any> {

        private form: ClientFunctionScheduleForm = new ClientFunctionScheduleForm(this.idPrefix);

        constructor(opt: ClientFunctionScheduleDialogOptions) {
            super(opt);

            this.dialogTitle = "Schedule";

            this.propertyGrid.load(opt || {});
        }

        protected getDialogButtons() {
            return [
                {
                    text: "OK",
                    click: () => {
                        if (!this.validateForm())
                            return;

                        if (!this.onSuccess ||
                            this.onSuccess(this.form.ScheduleName.value))
                            this.dialogClose();
                    },
                },
                {
                    text: "Cancel",
                    click: () => this.dialogClose()
                }
            ];
        }

        onDialogOpen() {
            super.onDialogOpen();

            if (!Q.isEmptyOrNull(this.options.Schedule)) {
                this.form.ScheduleName.value = this.options.Schedule;
            }
        }

        getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.width = 600;

            return opt;
        }

        public onSuccess: (scheduleName: string) => boolean;
    }
}